var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-listing"},[(_vm.editEmbed)?_c('EmbedEdit',{attrs:{"embed":_vm.embed}}):_c('EmbedView',{attrs:{"embed":_vm.listing,"editable":_vm.editable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }